const video = {
  root: "video",
  root_plural: "videos",
  begin_duration: "Start time",
  prestation: "Benefit",
};
export default video;
